import { BrowserRouter as Router } from "react-router-dom";

import AppRoutes from "./installations/routes/AppRoutingProvider";
import HeaderComponent from "./components/layouts/header/HeaderComponent";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DialogManagerComponent from "./components/dialogs/DialogManagerComponent";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import categoryActions from "./store/actions/products/categories/category.actions";
import websiteConfigurationActions from "./store/actions/websiteConfigurations/websiteConfiguration.actions";
import { ToastContainer } from "react-toastify";
import FooterComponent from "./features/layout/footer/FooterComponent";

import "./styles/components/app.scss";

// Create a Query Client instance
const queryClient = new QueryClient();

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const params = { getAll: true };
    dispatch(categoryActions.getCategories(params));
    dispatch(websiteConfigurationActions.getAllConfigurations());
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="app">
          <HeaderComponent />
          {/* <div className="container"> */}
          <AppRoutes />
          {/* </div> */}
          <FooterComponent />
        </div>
        <DialogManagerComponent />
        <ToastContainer />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
